/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */
import { Stack } from '@fluentui/react'
import { Button } from '@fluentui/react-components'
import { ThumbDislike16Regular, ThumbLike16Regular } from '@fluentui/react-icons'
import { IconButton } from '@fluentui/react/lib/Button'
import React from 'react'

import { FeedbackUIProps, getFeedbackIconStyle } from '.'
import { FeedbackType } from '../../services/FeedbackService'
import { useStyles } from './FeedbackUI.style'


const FeedbackUI = (props: FeedbackUIProps) => {
    const feedbackIconStyle = getFeedbackIconStyle(props.useThumbIcons || false)
    const styles = useStyles();

    const onFeedbackClick = (type: FeedbackType) => {
        props.feedbackService.CollectFeedback(type, props.componentName)
    }

    return (
        <Stack
            className="modal-like-dislike-container"
            horizontal
            style={{
                margin: props.useMinimalPadding ? '0px' : '24px 24px',
                flexDirection: 'row',
                justifyContent: 'flex-end'
            }}
        >
            {props.useThumbIcons ? (
                <>
                    <Button
                        appearance="subtle"
                        disabled={props.isDisabled}
                        // aria-label={strings.getString('sendASmile')}
                        onClick={() => onFeedbackClick(FeedbackType.Like)}
                        icon={<ThumbLike16Regular />}
                            className={styles.thumbsButton}
                        tabIndex={0}
                    />
                    <Button
                        appearance="subtle"
                        disabled={props.isDisabled}
                        // aria-label={strings.getString('sendASmile')}
                        onClick={() => onFeedbackClick(FeedbackType.Dislike)}
                        icon={<ThumbDislike16Regular />}
                        className={styles.thumbsButton}
                        tabIndex={0}
                    />
                </>
            ) : (
                <>
                    <IconButton
                        styles={feedbackIconStyle}
                        disabled={props.isDisabled}
                        // ariaLabel={strings.getString('sendASmile')}
                        iconProps={{ iconName: 'Emoji2' }}
                        onClick={() => onFeedbackClick(FeedbackType.Like)}
                        tabIndex={1}
                    />
                    <IconButton
                        styles={feedbackIconStyle}
                        disabled={props.isDisabled}
                        /// ariaLabel={strings.getString('sendAFrown')}
                        iconProps={{ iconName: 'Sad' }}
                        onClick={() => onFeedbackClick(FeedbackType.Dislike)}
                        tabIndex={2}
                    />
                </>
            )}
        </Stack>
    )
}

export default FeedbackUI
